import axios from "axios";

import { FULFILLED, PENDING, REJECTED } from "./action-type.util";

const ACTION_TYPES = {
  FETCH_OPTIONS: "prospects/FETCH_OPTIONS",
};

const initialState = {
  loading: false,
  selectStateList: [],
};

export type ProspectsBuilderState = Readonly<typeof initialState>;

export default (state: ProspectsBuilderState = initialState, action): ProspectsBuilderState => {
  const actionMap = {
    [PENDING(ACTION_TYPES.FETCH_OPTIONS)]: () => ({
      ...state,
      loading: true,
    }),
    [FULFILLED(ACTION_TYPES.FETCH_OPTIONS)]: () => ({
      ...state,
      selectStateList: action.payload.data.selectStateList || action.payload.data,
      loading: false,
    }),
    [REJECTED(ACTION_TYPES.FETCH_OPTIONS)]: () => ({
      ...state,
      loading: false,
    }),
  };
  const targetFunction = actionMap[action.type];
  return targetFunction ? targetFunction() : { ...state };
};

export const fetchProspectsOptions = () => ({
  type: ACTION_TYPES.FETCH_OPTIONS,
  payload: axios.get("prospects/new"),
});
